/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 598:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LnxProductParams = function (_HTMLElement) {
  _inherits(LnxProductParams, _HTMLElement);

  var _super = _createSuper(LnxProductParams);

  function LnxProductParams() {
    var _this;

    _classCallCheck(this, LnxProductParams);

    _this = _super.call(this);
    _this._boundOnVariantChange = _this._onVariantChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LnxProductParams, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      document.addEventListener('on:variant:change', this._boundOnVariantChange);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('on:variant:change', this._boundOnVariantChange);
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.id) return;
      var wraps = this.querySelectorAll('[data-variant-id]');
      var anyVisible = false;
      wraps.forEach(function (el) {
        var variantId = el.getAttribute('data-variant-id');

        if (variantId && String(variant.id) === String(variantId)) {
          el.removeAttribute('hidden');
          anyVisible = true;
        } else {
          el.setAttribute('hidden', '');
        }
      });

      if (anyVisible) {
        this.removeAttribute('hidden');
      } else {
        this.setAttribute('hidden', '');
      }
    }
  }]);

  return LnxProductParams;
}(_wrapNativeSuper(HTMLElement));

if (!customElements.get('lnx-product-params')) {
  customElements.define('lnx-product-params', LnxProductParams);
}

/***/ }),

/***/ 244:
/***/ (function() {

(function () {
  var isTouchDevice = false;
  var VIEWPORT_PADDING = 8;

  var onFirstTouch = function onFirstTouch() {
    isTouchDevice = true;
    window.removeEventListener('touchstart', onFirstTouch);
  };

  window.addEventListener('touchstart', onFirstTouch, {
    passive: true
  });

  function positionTooltip(pictogram) {
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
    if (!tooltip) return;
    pictogram.classList.remove('tooltip-align-left', 'tooltip-align-right');
    tooltip.style.opacity = '0';
    tooltip.style.visibility = 'visible';
    var tipRect = tooltip.getBoundingClientRect();
    var viewportWidth = window.innerWidth;
    tooltip.style.opacity = '';
    tooltip.style.visibility = '';

    if (tipRect.left < VIEWPORT_PADDING) {
      pictogram.classList.add('tooltip-align-left');
    } else if (tipRect.right > viewportWidth - VIEWPORT_PADDING) {
      pictogram.classList.add('tooltip-align-right');
    }
  }

  function showTooltipAria(pictogram) {
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
    if (!tooltip) return;
    tooltip.setAttribute('aria-hidden', 'false');
    if (tooltip.id) pictogram.setAttribute('aria-describedby', tooltip.id);
  }

  function hideTooltipAria(pictogram) {
    pictogram.removeAttribute('aria-describedby');
    var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
    if (tooltip) tooltip.setAttribute('aria-hidden', 'true');
  }

  var activePictograms = new Set();

  function deactivatePictogram(el) {
    el.classList.remove('is-active');
    hideTooltipAria(el);
    activePictograms.delete(el);
  }

  function getPictogramFromTarget(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('.product-pictogram');
  }

  function initPictogramTooltips() {
    activePictograms.clear();
    var containers = document.querySelectorAll('.product-pictograms');
    containers.forEach(function (container) {
      if (container.dataset.pictogramsInit === '1') return;
      container.addEventListener('mouseover', function (e) {
        var pictogram = getPictogramFromTarget(e.target);
        if (!pictogram || !container.contains(pictogram)) return;
        if (pictogram.contains(e.relatedTarget)) return;
        positionTooltip(pictogram);
        showTooltipAria(pictogram);
      });
      container.addEventListener('mouseout', function (e) {
        var pictogram = getPictogramFromTarget(e.target);
        if (!pictogram || !container.contains(pictogram)) return;
        if (pictogram.contains(e.relatedTarget)) return;
        hideTooltipAria(pictogram);
      });
      container.addEventListener('focusin', function (e) {
        var pictogram = getPictogramFromTarget(e.target);
        if (!pictogram || !container.contains(pictogram)) return;
        positionTooltip(pictogram);
        showTooltipAria(pictogram);
      }, true);
      container.addEventListener('focusout', function (e) {
        var pictogram = getPictogramFromTarget(e.target);
        if (!pictogram || !container.contains(pictogram)) return;
        hideTooltipAria(pictogram);
      }, true);
      container.addEventListener('click', function (e) {
        if (!isTouchDevice) return;
        var pictogram = getPictogramFromTarget(e.target);
        if (!pictogram || !container.contains(pictogram)) return;
        activePictograms.forEach(function (el) {
          if (el !== pictogram) deactivatePictogram(el);
        });
        var tooltip = pictogram.querySelector('.product-pictogram__tooltip');
        if (!tooltip) return;
        positionTooltip(pictogram);
        var isActive = pictogram.classList.toggle('is-active');

        if (isActive) {
          activePictograms.add(pictogram);
          showTooltipAria(pictogram);
        } else {
          deactivatePictogram(pictogram);
        }
      });
      container.dataset.pictogramsInit = '1';
    });
  }

  initPictogramTooltips();
  document.addEventListener('shopify:section:load', initPictogramTooltips);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      activePictograms.forEach(deactivatePictogram);
      activePictograms.clear();
    }
  });
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_lnx_product_params__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(598);
/* harmony import */ var _partials_lnx_product_params__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_lnx_product_params__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _partials_product_pictograms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(244);
/* harmony import */ var _partials_product_pictograms__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_partials_product_pictograms__WEBPACK_IMPORTED_MODULE_1__);




}();
/******/ })()
;